import React from 'react';
import { Card, Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { InfoBox } from './dual-billing-overview.style';
import { PaymentSplit, PaymentSplitProps } from './payment-split.component';

const getCopy = copyFor('billing.statement.dualBillingOverview');

type Props = PaymentSplitProps;

export const DualBillingOverview: React.FC<Props> = props => {
  return (
    <Card mobileVariant="flat" margin={{ bottom: '32px' }}>
      <Card.Content>
        <Text
          textStyle="heading700"
          tag="h2"
          margin={{ top: '24px', bottom: '40px' }}
        >
          {getCopy('title')}
        </Text>
        <Text>{getCopy('explanation')}</Text>
        <PaymentSplit {...props} />
        <Info />
      </Card.Content>
    </Card>
  );
};

const Info: React.FC = () => {
  return (
    <InfoBox>
      <table role="presentation">
        <tr>
          <td style={{ paddingRight: '8px', verticalAlign: 'top' }}>
            <Icon icon="InfoCircleInverted" />
          </td>
          <td>
            <Text textStyle="paragraph400" color="secondary">
              {getCopy('info')}
            </Text>
          </td>
        </tr>
      </table>
    </InfoBox>
  );
};
